<template>
  <div class="homemenu_fluid">
    <div class="homemenu between">
      <lv-nav-menu class="Popular_law" :list='catslist'/>
      <div class="banner">
        <div class="index_swiper">
          <el-carousel
            trigger="click"
            height="233px"
            indicator-position="none"
            arrow="never"
            ref="elswipe"
            @change="swiperchange"
          >
            <el-carousel-item v-for="item in 4" :key="item">
              <div class="index_swiper_item">
                <img src="~assets/home/banner_sample_1.png" />
              </div>
            </el-carousel-item>
          </el-carousel>

          <div class="swiper_bottom between text_center FontSize14">
            <div
              v-for="(btmitem, index) in laywercates"
              :key="btmitem"
              @click="changeswipe(index)"
              :class="{ swiper_active: index == current_swiper }"
            >
              {{btmitem}}
            </div>
          </div>
        </div>

        <div class="recommend_lawyer between wrap">
          <div class="recom_law_item" v-for="(item, index) in laywerlist.slice(0,8)" :key="index">
            <div class="item" :class="{ item1: index == 0 || index == 4 }">
              <img :src="item.avatar" />
              <div class="lay_info FontSize14 text_center">{{item.lawyer_name}}律师</div>
            </div>
          </div>
        </div>
      </div>
      <div class="quick">
        <div class="title">热门法律领域</div>
        <div class="quick_entry">
          <div class="current text_center text_hover_shou">
            <div><img src="~assets/home/diqu.png" /></div>
            <div>合肥律师站</div>
          </div>
          <div class="fast_list between wrap text_center">
            <div class="fast_item margin_bottom30">
				<router-link to="/findLawyers">
              <div class="f_item_icon f_item_icon1"></div>
              
				  <div >按在线找律师</div>
			  </router-link>
            </div>
            <div class="fast_item margin_bottom30">
              <router-link to='/findLawyers/field'>
				  <div class="f_item_icon f_item_icon2"></div>
				  <div>按专长找律师</div>
			  </router-link>
            </div>
            <div class="fast_item">
            <router-link to="/findLawyers/lawyeroffice">
				<div class="f_item_icon f_item_icon3"></div>
				<div>按律所找律师</div>
			</router-link>
            </div>
            <div class="fast_item">
             <router-link to="/findLawyers/ls">
				 <div class="f_item_icon f_item_icon4"></div>
				 <div >按问题找律师</div>
			 </router-link>
            </div>
          </div>
        </div>
        <div class="quick_consult text_center">
          <div class="qc1">在线律师</div>
          <div class="qc2">精选本地律师服务，点击快速咨询</div>
          <router-link to="/findLawyers">
			  <div class="qc3btn">快速咨询</div>
		  </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lvNavMenu from "components/content/lvNavMenu/lvNavMenu";
export default {
  name: "homemenubanner",
  components: { lvNavMenu },
  data() {
    return {
      current_swiper: 0,
	  
	  laywercates:['优选律师','委托律师','执业律师','甄选律师'],
	  catslist:[],
	  laywerlist:[]
    };
  },
  created() {
  	this.$http.home.knowledgecats().then(res => {
  		console.log(res)
  		this.catslist = res.data
  	})
	this.getdatalist(2)
	
  },
  methods: {
	  getdatalist(id){
		  this.$http.home.lawyerads({
		  	ad_id:id,
		  	limit:8,
		  }).then(res => {
		  	this.laywerlist = res.data.data
		  })
	  },
    swiperchange(e) {
      // this.current_swiper = e;
    },
    changeswipe(e) {
		this.current_swiper = e
		switch (e){
			case 0:
			this.getdatalist(2)
				break;
			case 1:
			this.getdatalist(3)
				break;
			case 2:
			this.getdatalist(4)
				break;
			case 3:
			this.getdatalist(5)
				break;
			default:
				break;
		}
      // this.$refs.elswipe.setActiveItem(e);
	  
    },
  },
};
</script>

<style lang="scss" scoped>
.homemenu_fluid {
  width: 100%;
  background-color: #f8f8f8;
  padding: 24px 0 30px;
  .homemenu {
    width: 1200px;
    height: 560px;
    margin: 0 auto;

    .Popular_law {
      width: 280px;
      height: 100%;
    }
    .banner {
      width: 592px;
      height: 100%;

      .index_swiper {
        width: 596px;
        .swiper_bottom {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background-color: #f8f8f8;
          > div {
            width: 25%;
          }
        }
        .swiper_bottom {
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);
          .swiper_active {
            background-color: #0465ea;
            color: #fff;
          }
        }
      }

      .recommend_lawyer {
        background-color: #fff;
        margin-top: 12px;
        padding: 0px 9px 10px;
        .item {
          margin-top: 10px;
          position: relative;
          img {
            width: 120px;
            height: 125px;
            object-fit: none;
          }
          .lay_info {
            position: absolute;
            left: 0;
            bottom: 0;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);
            width: 100%;
            height: 24px;
            line-height: 24px;
          }
        }

        .item1 {
          img {
            width: 187px;
          }
        }
      }
    }
    .quick {
      width: 280px;
      height: 100%;
      > .title {
        height: 46px;
        line-height: 46px;
        text-align: center;
        font-size: 22px;
        color: #fff;
        background-image: url("~assets/home/blue_line_bg.png");
        margin-bottom: 0;
        width: 280px;
      }
      .quick_entry {
        background-color: #fff;
        padding: 0 12px;
        color: #333;
        .current {
          padding: 28px 0 24px;
          font-size: 20px;
          border-bottom: 1px solid #eeeeee;
          img {
            margin-bottom: 18px;
          }
        }
        .fast_list {
          padding: 25px 0;
          > div {
            width: 50%;
            font-size: 14px;
            cursor: pointer;
          }
          .fast_item {
            &:hover {
              color: #0465ea;
              .f_item_icon {
                background-position-y: -29px;
              }
            }
          }
          .f_item_icon {
            width: 29px;
            height: 28px;
            margin: 0 auto 9px;
            transition: all 0.2s;
            background: url("~assets/home/navmenu_f_l.png") no-repeat;
          }

          .f_item_icon1 {
            background-position: -50px 0;
          }

          .f_item_icon2 {
            background-position: -150px 0;
          }

          .f_item_icon3 {
            background-position: -100px 0;
          }

          .f_item_icon4 {
            background-position: 0 0;
          }

          .margin_bottom30 {
            margin-bottom: 30px;
          }
          img {
          }
        }
      }

      .quick_consult {
        width: 280px;
        height: 173px;
        margin-top: 12px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
        padding: 35px 0;
        background: url("~assets/home/bg001.png");

        .qc1 {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .qc2 {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-top: 13px;
        }
        .qc3btn {
          width: 140px;
          height: 36px;
          line-height: 36px;
          margin: 15px auto 0;
          color: #fff;
          background: #f25618;
          border-radius: 17px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>